import {
  RequirementConditionOperator,
  RequirementConditionType
} from 'generated-graphql/types';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const getConversationAutomationScoreOperator = (
  analysisAutomationItem: AutomationFormItem
): RequirementConditionOperator => {
  const conversationScoreCondition =
    analysisAutomationItem.requirementConditions.find(
      (condition) =>
        condition.type === RequirementConditionType.ConversationScore
    );

  return (
    conversationScoreCondition?.operator ||
    RequirementConditionOperator.EqualToOrGreaterThan
  );
};
